import React, { useState, useEffect, useContext } from "react";
import { Stage, Layer, Image } from "react-konva";
import useImage from "use-image";
import HyPETMachine from "../../../assets/HyPETMachine.svg";
import Hypet_robot from "../../../assets/HyPET_Robot.svg";
import Hypet_ClampUnit from "../../../assets/HyPET_ClampUnit.svg";
import HyPET_InjectionUnit from "../../../assets/HyPET_InjectionUnit.svg";
import { MachineCanvasProps } from "../../../../InjectionCycle/components/interfaces";
import { KonvaEventObject } from "konva/lib/Node";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../../../App";

const HyPETCanvas: React.FC<MachineCanvasProps> = ({
  hoveredPart,
  setHoveredPart,
  machineName,
  navigationState,
}) => {

  const navigate = useNavigate();
  const appContextProps: any = useContext(AppContext)
  const [stageSize, setStageSize] = useState({
    width: window.innerWidth,
    height: 550,
  });

  const [HyPETImg] = useImage(HyPETMachine);
  const [RobotIMg] = useImage(Hypet_robot);
  const [ClampUnitImg] = useImage(Hypet_ClampUnit);
  const [InjectionUnitImg] = useImage(HyPET_InjectionUnit);

  const handleMouseMove = (e: KonvaEventObject<MouseEvent>) => {
    const { x, y } = e.target.getStage()?.getPointerPosition() || {
      x: 0,
      y: 0,
    };

    if (
      x >= stageSize.width * 0.22 &&
      x <= stageSize.width * 0.54 &&
      y >= stageSize.height * 0.1 &&
      y <= stageSize.height * 0.7
    ) {
      setHoveredPart("Clamp Unit");
    } else if (
      x >= stageSize.width * 0.5 &&
      x <= stageSize.width * 0.85 &&
      y >= stageSize.height * 0.26 &&
      y <= stageSize.height * 0.55
    ) {
      setHoveredPart("Injection Unit");
    } else {
      setHoveredPart("");
    }
  };

  useEffect(() => {
      const handleResize = () => {
        setStageSize({
          width: window.innerWidth - (appContextProps.sideBarOpenStatus ? 260 : 10),
          height: 550,
        });
      };
    handleResize(); // Call handleResize immediately to set the initial size
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [appContextProps.sideBarOpenStatus]);

  return (
    <Stage
      width={stageSize.width}
      height={stageSize.height}
      onMouseMove={handleMouseMove}
    >
      <Layer>
        <Image
          image={HyPETImg}
          x={stageSize.width * 0.12}
          y={stageSize.height * 0.12}
          width={stageSize.width * 0.75}
          height={stageSize.height * 0.75}
        />
        {/* {hoveredPart === 'Robot' && (
                    <Image
                        image={RobotIMg}
                        x={stageSize.width * 0.12}
                        y={stageSize.height * 0.124}
                        width={stageSize.width * 0.15}
                        height={stageSize.height * 0.75}
                        onClick={()=> navigate(`/usecase/injection-pdm/HyPET/${machineName}/Robot/asset-report/machine-view`)}
                    />
                )} */}
        {hoveredPart === "Clamp Unit" && (
          <Image
            image={ClampUnitImg}
            x={stageSize.width * 0.252}
            y={stageSize.height * 0.019}
            width={stageSize.width * 0.295}
            height={stageSize.height * 0.665}
            onClick={() =>
              navigate(
                `/usecase/injection-pdm/hypets/${machineName}/Clamp%20Unit/machineview`,
                { state: navigationState["Clamp Unit".toLowerCase()] }
              )
            }
          />
        )}
        {hoveredPart === "Injection Unit" && (
          <Image
            image={InjectionUnitImg}
            x={stageSize.width * 0.519}
            y={stageSize.height * 0.121}
            width={stageSize.width * 0.327}
            height={stageSize.height * 0.42}
            onClick={() =>
              navigate(
                `/usecase/injection-pdm/hypets/${machineName}/Injection%20Unit/machineview`,
                { state: navigationState["Injection Unit".toLowerCase()] }
              )
            }
          />
        )}
      </Layer>
    </Stage>
  );
};

export default HyPETCanvas;
